
/**
 *	h24 Store
 *	
 *	Zugriff innerhalb der Views / Components:
 *	this.$store.state.h24:
 *
 */

import ApiService from '@/services/api.service';

/**
 *	-----------------------------------------------------------
 *	States
 */
export const state = {
	h24: {}
}

/**
 *	-----------------------------------------------------------
 *	Mutations
 */
export const mutations = {

	/**
	 *	Überschreiben von Daten.
	 *	this.$store.commit('h24/MODIFY', {h24:{...}});
	 *	this.commit('h24/MODIFY', {h24:{...}});
	 */
	MODIFY (state, override = {}) {
		this.state.h24 = Object.assign(state, override)
	}

}

/**
 *	------------------------------------------------------------
 *	Actions
 */
export const actions = {

	/**
	 *	Daten aus dem Backend laden.
	 *	Wird in der main.js bei Initialisierung aufgerufen.
	 *	this.$store.dispatch('h24/LOAD').then(() => {...});
	 */
	LOAD () {
		return new Promise((resolve, reject) => {
			ApiService.loadData().then(( data ) => {
				this.commit('h24/MODIFY', data);
				resolve( data );
			});
		})
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
